import React, { useEffect } from 'react';

import CarouselComponent from '../common/carousel/CarouselComponent';
import HomeInitiativeComponent from './HomeInitiativeComponent';
import HomeOperationsComponent from './HomeOperationsComponent';
import HomeFeaturesComponent from './HomeFeaturesComponent';
import HomeEligibilityComponent from './HomeEligibilityComponent';
import HomeTestimonialsComponent from './HomeTestimonialsComponent';
import HomeApplyNowComponent from './HomeApplyNowComponent';
import ApplyNowModalComponent from '../common/header/ApplyNowModalComponent';

function HomeContainer() {
  
  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  return (
    <main role="main">
      <div className="app-home">

        {/* Carousel for SISFS */}
        <CarouselComponent />
        {/* Carousel for SISFS */}

        {/* section-initiative for SISFS */}
        <HomeInitiativeComponent />
        {/* section-initiative for SISFS */}

        {/* section-operation for how SISFS operate*/}
        <HomeOperationsComponent />
        {/* section-operation for how SISFS operate*/}

        {/* section-features of SISFS*/}
        <HomeFeaturesComponent />
        {/* section-features of SISFS*/}

        {/* section-eligibility for SISFS*/}
        <HomeEligibilityComponent />
        {/* section-eligibility for SISFS*/}

        {/* section-testimonials for SISFS*/}
        <HomeTestimonialsComponent />
        {/* section-testimonials for SISFS*/}

        {/* section-apply now for SISFS*/}
        <HomeApplyNowComponent />
        {/* section-apply now for SISFS*/}
        {/* apply now modal */}
        <ApplyNowModalComponent />

      </div>
    </main>
  );
}

export default HomeContainer;
